export default __webpack_public_path__ + "static/media/close.a97d636b.svg";